import React from 'react';
import ClickCollectView from './ClickCollectView';
import ReservationPage from './ReservationPage';
import './CustomerChatbotActions.css';

export default function CustomerChatbotActions({ type, onClose }) {
  if (!['order', 'reservation'].includes(type)) return null;
  return <section className="customer-chat-preparation" aria-label={type === 'order' ? 'Préparation de commande' : 'Préparation de réservation'}>
    <header className="customer-chat-preparation-header">
      <button type="button" onClick={onClose}>Revenir à l’assistant sans perdre ma préparation</button>
      <p>{type === 'order'
        ? 'Choisissez vos articles et vérifiez le total. « Payer maintenant » confirme la commande puis ouvre la page de paiement sécurisée. Ne communiquez aucune donnée bancaire dans le chat. Le restaurant reçoit la confirmation du paiement du prestataire.'
        : 'Choisissez un créneau et vos coordonnées. La demande sera transmise seulement après votre confirmation dans le formulaire, puis le restaurant confirmera la disponibilité.'}</p>
    </header>
    {type === 'order' ? <ClickCollectView embedded /> : <ReservationPage />}
  </section>;
}
